import React, { useEffect, useState } from "react";
import "../styles/ActivePromotion.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import EditDetails from "../icons/BusinessHub/EditDetails.js";
import TrashIcon from "../icons/BusinessHub/TrashIcon.js";
import TagIcon from "../icons/TagIcon.js";
import DateIcon from "../icons/BusinessHub/DateIcon.js";
import ProductBox from "../icons/ProductBox.js";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import CustomDropdown from "./StatusDropdown.js";
import FilterIcon from "../icons/BusinessHub/FilterIcon.js";
import PlusIcon from "../icons/BusinessHub/PlusIcon.js";
import XIcon from "../icons/XIcon.js";
import SearchIcon from "../icons/BusinessHub/SearchIcon.js";
import SaveIcon from "../icons/SaveIcon.js";
import BoxIcon from "../icons/BoxIcon.js";
import BinIcon from "../icons/BusinessHub/BinIcon.js";
import { useLocation } from "react-router-dom";
import ProductController from "../controllers/ProductController.js";
import { userService } from "../services/userService.js";
import { useNavigate } from "react-router-dom";
import PromotionController from "../controllers/PromotionController.js";
import dayjs from "dayjs";

function ActivePromotion() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialMode =
    location.state?.Mode ?? searchParams.get("mode") === "edit";
  const initialProductOfferId =
    location.state?.PID ?? searchParams.get("pid") ?? "";
  const [CampaignOfferType, setCampaignOfferType] = useState("");
  const [Mode, setMode] = useState(initialMode);
  const PID = initialProductOfferId;
  const [CampaignDetails, setCampaignDetails] = useState();
  const [productsInCampaign, setproductsInCampaign] = useState([]);
  const [mockproducts, setmockproduct] = useState([]);
  const [productsearch, setProductsearch] = useState("");
  const [selectedproducts, setSelectedproducts] = useState([]);
  const [selectedskus, setSelectedskus] = useState([]);
  const [expandedproducts, setExpandedproducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [mockCategoryOptions, setmockCategoryOptions] = useState([]);
  const [CategoryOptions, setCategoryOptions] = useState([]);
  const [categoriesHydrated, setCategoriesHydrated] = useState(false);
  const [campaignSelectionHydrated, setCampaignSelectionHydrated] =
    useState(false);
  const [description, setDescription] = useState("");
  const [value, setValue] = useState();
  const [DeleteCamp, setDeleteCamp] = useState(false);
  const [addProdSku, setaddProdSku] = useState(false);
  const [discountUnit, setDiscountUnit] = useState("PERCENTAGE");
  const [SelectFilter, setSelectFilter] = useState(false);
  const views = 2847;
  const clicks = 1234;
  const conversion = 156;
  const Clickrange = (clicks * 100) / views;
  const Convrange = (conversion * 100) / views;

  const formatreviewdate = (value) => {
    if (!value) return "";

    const [day, month, year] = value.split("/");

    const parsed = new Date(Number(year), Number(month) - 1, Number(day));

    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    const monthName = parsed.toLocaleString("en-US", {
      month: "short",
    });

    const dayNumber = parsed.getDate();
    const fullYear = parsed.getFullYear();

    return `${monthName} ${dayNumber},${fullYear}`;
  };

  useEffect(() => {
    // Runs once when the component mounts
    // Fetch all categories from API and normalize them for dropdown usage
    const getdata = async () => {
      const res = await ProductController.getAllCategories({
        Authorization: userService.getUser(),
      });

      const normalized = Array.from(
        new Map(
          (res?.data || []).map((c) => [
            c.categoryId,
            {
              id: c.categoryId,
              name: c.categoryName,
              label: c.categoryName,
              value: c.categoryId,
            },
          ]),
        ).values(),
      );
      setCategoryOptions(normalized);
    };
    getdata();
  }, []);

  const normalizeToArray = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (value === null || value === undefined || value === "") return [];
    return [value];
  };

  const getCampaignProductIds = (campaign) =>
    Array.from(
      new Set(
        normalizeToArray(
          campaign?.productAndSku?.productID ??
            campaign?.productAndSku?.productId,
        ),
      ),
    );

  const getCampaignSkuIds = (campaign) =>
    Array.from(
      new Set(
        normalizeToArray(
          campaign?.productAndSku?.skuId ??
            campaign?.productAndSku?.skuID ??
            campaign?.productAndSku?.skuIDs,
        ).map((skuId) => String(skuId)),
      ),
    );

  const normalizeCatalogProduct = (product, productIndex) => {
    // Purpose: standardize product data from different API response formats
    const productId =
      // Tries multiple possible fields to ensure product always has an ID
      product?.productID ??
      product?.productId ??
      product?.id ??
      product?.catalogId ??
      product?.productCatalogId ??
      `campaign-product-${productIndex + 1}`;

    const skuDetailSource = Array.isArray(product?.skuDetails)
      ? product.skuDetails
      : [];
    const skuIdSource = normalizeToArray(
      product?.skuIDs ?? product?.skuIds ?? product?.skuID,
    );
    const normalizedSkuSource = skuDetailSource.length
      ? skuDetailSource
      : skuIdSource.map((skuId, skuIndex) => ({
          skuID: skuId,
          skuCode: product?.skuCode ?? `SKU ${skuIndex + 1}`,
          code: product?.skuCode ?? `SKU ${skuIndex + 1}`,
          color: product?.colorName ?? null,
          url: product?.images?.[0] ?? "",
          stockQuantity:
            product?.stockQuantity ?? product?.quantity ?? product?.stock ?? 0,
          productName: product?.productName ?? product?.name,
        }));

    return {
      id: productId,
      // Output structure used throughout UI and logic
      name:
        product?.productName ??
        product?.name ??
        product?.title ??
        product?.productTitle ??
        "Unnamed Product",
      category:
        product?.categoryName ??
        product?.category ??
        product?.basicInfo?.categoryName ??
        product?.basicInfo?.category ??
        product?.productCategory ??
        "Uncategorized",
      categoryId:
        product?.categoryId ??
        product?.basicInfo?.categoryId ??
        product?.basicInfo?.categoryID ??
        null,
      vendor: product?.vendor ?? product?.brand ?? "",
      image:
        product?.image ??
        product?.imageUrl ??
        product?.productImage ??
        product?.images?.[0] ??
        "",
      skus: normalizedSkuSource.map((sku, skuIndex) => ({
        id:
          sku?.skuID ??
          sku?.id ??
          sku?.productCatalogId ??
          `${productId}-sku-${skuIndex + 1}`,
        name:
          sku?.color ??
          sku?.name ??
          sku?.skuName ??
          sku?.code ??
          sku?.skuCode ??
          sku?.skuID ??
          sku?.id ??
          sku?.productName ??
          "Unnamed SKU",
        code:
          sku?.code ??
          sku?.sku ??
          sku?.skuCode ??
          sku?.SKU ??
          sku?.skuID ??
          sku?.id ??
          "N/A",
        stock:
          sku?.stock ??
          sku?.stockQuantity ??
          sku?.quantity ??
          sku?.availableStock ??
          0,
        color: sku?.color ?? sku?.colorName ?? null,
        image: sku?.url ?? product?.images?.[0] ?? "",
      })),
    };
  };

  const getSkuDisplayText = (sku) => {
    if (!sku) return "No SKU assigned";
    if (typeof sku === "string" || typeof sku === "number") return String(sku);

    return (
      sku?.code ??
      sku?.skuCode ??
      sku?.color ??
      sku?.skuID ??
      sku?.id ??
      sku?.name ??
      sku?.skuName ??
      sku?.productName ??
      sku?.skuCode ??
      sku?.code ??
      sku?.barcode ??
      sku?.skuID ??
      "Unnamed SKU"
    );
  };

  const getCategoryKey = (category) =>
    category?.value ??
    category?.id ??
    `${category?.label || category?.name || ""}`;

  const dedupeCategories = (categories) =>
    Array.from(
      new Map(
        (categories || [])
          .filter(Boolean)
          .map((category) => [getCategoryKey(category), category]),
      ).values(),
    );

  const campaignCategoryFallbackOptions = Array.isArray(
    CampaignDetails?.category,
  )
    ? CampaignDetails.category
        .map((category) => {
          const categoryId = category?.categoryID ?? category?.categoryId;
          const categoryName = category?.categoryName || category?.name || "";

          if (!categoryId) return null;

          return {
            id: categoryId,
            label: categoryName || String(categoryId),
            name: categoryName || String(categoryId),
            value: categoryId,
          };
        })
        .filter(Boolean)
    : [];

  const uniqueCategoryOptions = dedupeCategories([
    ...CategoryOptions,
    ...campaignCategoryFallbackOptions,
    ...mockCategoryOptions,
  ]);
  const selectedCategoryDetails = uniqueCategoryOptions.filter((category) =>
    selectedCategories.includes(category.id),
  );
  const selectedCategoryIds = Array.from(
    new Set(
      selectedCategoryDetails.map((category) => category.id).filter(Boolean),
    ),
  );
  const selectedCategoryIdsKey = selectedCategoryIds.join("|");

  const selectedCategorySummary = selectedCategoryDetails?.length
    ? // Purpose: create a readable string of selected category names for UI display
      selectedCategoryDetails
        .map((category) => category?.label || category?.name || category?.id)
        .join(" - ")
    : "No categories selected";

  const selectedProductDetails = mockproducts.filter((product) =>
    // Purpose: retrieve full product objects based on selected product IDs
    selectedproducts.includes(product.id),
  );

  const selectedSkuDetails = mockproducts.flatMap((product) =>
    // Purpose: collect all selected SKUs across all products
    product.skus.filter((sku) => selectedskus.includes(sku.id)),
  );

  const selectedSummaryLabel = `${selectedSkuDetails?.length} SKUs selected`;
  // Displays number of selected SKUs

  const selectedSummaryMeta = `from ${selectedProductDetails?.length} products`;
  // Displays number of products that contain selected SKUs

  const visibleproducts = mockproducts.filter(
    // Purpose:
    // 1. Filter by selected categories
    // 2. Filter by search input (name, vendor, category, SKU data)
    (product) => {
      const productCategoryId = product.categoryId;
      const productCategory =
        product.categoryName ??
        (typeof product.category === "string"
          ? product.category
          : product.category?.categoryName || "");

      return (
        (!selectedCategories?.length ||
          (productCategoryId &&
            selectedCategories.includes(productCategoryId))) &&
        `${product.name} ${product.vendor} ${productCategory} ${product.skus
          .map((sku) => `${sku.name} ${sku.code}`)
          .join(" ")}`
          .toLowerCase()
          .includes(productsearch.toLowerCase())
      );
    },
  );

  const formatDisplayDate = (value) => {
    // Purpose: normalize and format date strings into readable format
    if (!value) return "-";

    const normalizedValue = String(value).replace(
      /^([A-Za-z]{3})\s+(\d{1,2}),(\d{4})$/,
      "$1 $2, $3",
    );
    const parsedDate = new Date(normalizedValue);

    if (Number.isNaN(parsedDate.getTime())) {
      return normalizedValue;
    }

    return parsedDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleRemoveCategory = (categoryToRemove) => {
    // Purpose: remove a selected category from state
    setSelectedCategories((prev) =>
      prev.filter((categoryId) => categoryId !== categoryToRemove.id),
    );
  };

  const handleToggleProduct = (product) => {
    // Purpose:
    // - Select/deselect a product
    // - Manage related SKUs automatically
    // - Maintain expanded UI state
    const isSelected = selectedproducts.includes(product.id);
    const productSkuIds = product.skus.map((sku) => sku.id);

    if (isSelected) {
      setSelectedproducts((prev) => prev.filter((item) => item !== product.id));
      setExpandedproducts((prev) => prev.filter((item) => item !== product.id));
      setSelectedskus((prev) =>
        prev.filter((skuId) => !productSkuIds.includes(skuId)),
      );
      return;
    }

    setSelectedproducts((prev) => [...prev, product.id]);
    setExpandedproducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
    setSelectedskus((prev) => [
      ...prev,
      ...productSkuIds.filter((skuId) => !prev.includes(skuId)),
    ]);
  };

  const handleToggleSku = (product, skuId) => {
    // Purpose: handle individual SKU selection and sync with product selection
    const isSkuSelected = selectedskus.includes(skuId);

    if (isSkuSelected) {
      const remainingSkuIds = product.skus
        .map((sku) => sku.id)
        .filter((id) => id !== skuId && selectedskus.includes(id));

      setSelectedskus((prev) => prev.filter((item) => item !== skuId));
      if (!remainingSkuIds?.length) {
        setSelectedproducts((prev) =>
          prev.filter((item) => item !== product.id),
        );
      }
      return;
    }

    setSelectedskus((prev) => [...prev, skuId]);
    setSelectedproducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
    setExpandedproducts((prev) =>
      prev.includes(product.id) ? prev : [...prev, product.id],
    );
  };

  useEffect(() => {
    // Purpose:
    // - Fetch promotion details
    // - Extract product IDs
    // - Fetch full product details
    // - Build category list for filtering
    const fetchData = async () => {
      try {
        setCategoriesHydrated(false);
        setCampaignSelectionHydrated(false);
        setSelectedCategories([]);
        setmockCategoryOptions([]);
        const res = await ProductController.getPromotionDetailsById({
          Authorization: userService.getUser(),
          productOfferId: PID,
        });
        setCampaignOfferType(res?.data?.offerType);
        const campaign = res?.data;
        const productIds = getCampaignProductIds(campaign);
        setValue(res?.data?.discountValue);
        if (!Array.isArray(productIds) || productIds.length === 0) {
          setCampaignDetails(campaign);
          setproductsInCampaign([]);
          setmockCategoryOptions([]);
          return;
        }

        const results = await Promise.all(
          productIds.map((id) =>
            ProductController.getProductDetails({
              Authorization: userService.getUser(),
              productRequest: {
                businessProfileID: userService.getBPID(),
                companyId: userService.getCompID(),
                productId: id,
              },
            }),
          ),
        );

        const products = results.map((r) => r?.data).filter(Boolean);
        setproductsInCampaign(products);
        const formattedCategories = products
          .map((item) => {
            const categoryId = item?.basicInfo?.categoryId;
            const categoryName =
              item?.basicInfo?.categoryName ?? item?.basicInfo?.category;

            if (!categoryId) return null;

            return {
              id: categoryId,
              label: categoryName || String(categoryId),
              name: categoryName || String(categoryId),
              value: categoryId,
            };
          })
          .filter(Boolean);

        const uniqueCategories = Array.from(
          new Map(formattedCategories.map((c) => [c.value, c])).values(),
        );
        setmockCategoryOptions(uniqueCategories);
        setCampaignDetails(campaign);
      } catch (error) {
        console.error(error);
        setCampaignDetails(undefined);
        setproductsInCampaign([]);
        setmockCategoryOptions([]);
      }
    };

    if (PID) fetchData();
  }, [PID]);

  useEffect(() => {
    if (categoriesHydrated || !CampaignDetails) return;

    const promotionCategoryIds = Array.isArray(CampaignDetails?.category)
      ? Array.from(
          new Set(
            CampaignDetails.category
              .map((category) => category?.categoryID ?? category?.categoryId)
              .filter(Boolean),
          ),
        )
      : [];

    const nextSelected = promotionCategoryIds.length
      ? promotionCategoryIds
      : mockCategoryOptions.map((category) => category.id).filter(Boolean);

    setSelectedCategories(nextSelected);
    setCategoriesHydrated(true);
  }, [CampaignDetails, mockCategoryOptions, categoriesHydrated]);

  useEffect(() => {
    if (campaignSelectionHydrated || !CampaignDetails || !mockproducts.length) {
      return;
    }

    const campaignProductIds = new Set(getCampaignProductIds(CampaignDetails));
    const campaignSkuIds = new Set(getCampaignSkuIds(CampaignDetails));

    const nextSelectedProducts = mockproducts
      .filter((product) => {
        const hasMatchingSku = product.skus.some((sku) =>
          campaignSkuIds.has(String(sku.id)),
        );

        return campaignProductIds.has(product.id) || hasMatchingSku;
      })
      .map((product) => product.id);

    const nextSelectedSkus = mockproducts.flatMap((product) =>
      product.skus
        .filter((sku) => campaignSkuIds.has(String(sku.id)))
        .map((sku) => sku.id),
    );

    setSelectedproducts(nextSelectedProducts);
    setSelectedskus(nextSelectedSkus);
    setExpandedproducts(nextSelectedProducts);
    setCampaignSelectionHydrated(true);
  }, [CampaignDetails, campaignSelectionHydrated, mockproducts]);

  useEffect(() => {
    const getProductCatalog = async () => {
      if (!selectedCategoryIds?.length) {
        setmockproduct([]);
        setSelectedproducts([]);
        setSelectedskus([]);
        setExpandedproducts([]);
        return;
      }

      try {
        const results = await Promise.all(
          selectedCategoryIds.map((categoryId) =>
            ProductController.getProductCatalog({
              Authorization: userService.getUser(),
              companyID: userService.getCompID(),
              brand: "",
              categoryId,
              color: "",
              maxPrice: "",
              minPrice: "",
              productCompanyStatus: "1",
              productSystemStatus: "1",
              page: 1,
              search: "",
              size: "",
              sizePage: 1000000,
              sortBy: "",
              sortDirection: "",
            }),
          ),
        );
        const merged = results
          .flatMap((res) => {
            if (Array.isArray(res?.data)) {
              return res.data;
            }

            if (Array.isArray(res?.data?.rows)) {
              return res.data.rows;
            }

            return [];
          })
          .map((product, productIndex) =>
            normalizeCatalogProduct(product, productIndex),
          );

        const uniqueProducts = Array.from(
          new Map(merged.map((product) => [product.id, product])).values(),
        );
        setmockproduct(uniqueProducts);
        setSelectedproducts((prev) =>
          prev.filter((productId) =>
            uniqueProducts.some((product) => product.id === productId),
          ),
        );
        setSelectedskus((prev) =>
          prev.filter((skuId) =>
            uniqueProducts.some((product) =>
              product.skus.some((sku) => sku.id === skuId),
            ),
          ),
        );
        setExpandedproducts((prev) =>
          prev.filter((productId) =>
            uniqueProducts.some((product) => product.id === productId),
          ),
        );
      } catch (err) {
        console.error(err);
        setmockproduct([]);
        setSelectedproducts([]);
        setSelectedskus([]);
        setExpandedproducts([]);
      }
    };

    getProductCatalog();
  }, [selectedCategoryIdsKey]);

  useEffect(() => {
    const validProductIds = new Set(mockproducts.map((product) => product.id));
    const validSkuIds = new Set(
      mockproducts.flatMap((product) => product.skus.map((sku) => sku.id)),
    );

    setSelectedproducts((prev) =>
      prev.filter((productId) => validProductIds.has(productId)),
    );
    setExpandedproducts((prev) =>
      prev.filter((productId) => validProductIds.has(productId)),
    );
    setSelectedskus((prev) => prev.filter((skuId) => validSkuIds.has(skuId)));
  }, [mockproducts]);

  const formatStatus = (status) => {
    if (!status) return "";

    const lower = status.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  const DeletePromotion = async () => {
    try {
      const deletePromotionByProductOfferId =
        await PromotionController.deletePromotionByProductOfferId({
          Authorization: userService.getUser(),
          productOfferId: PID,
        });
      if (deletePromotionByProductOfferId.data === true) {
        navigate("/promotions-and-marketing");
      }
    } catch (error) {
      console.log("error");
    }
  };
  const EditPromotion = async () => {
    const normalizedCampaignProductIds = getCampaignProductIds(CampaignDetails);
    const normalizedCampaignSkuIds = getCampaignSkuIds(CampaignDetails);
    const request = {
      categoryId: selectedCategoryIds,
      description: description || CampaignDetails?.description || "",
      discountValue: value || CampaignDetails?.discountValue || "",
      discountValueType:
        discountUnit || CampaignDetails?.discountValueType || "PERCENTAGE",
      endDate: CampaignDetails?.endDate || "",
      offerType: "SUMMER_SALE",
      productAndSku: {
        productID: selectedproducts.length
          ? selectedproducts
          : normalizedCampaignProductIds,
        skuId: selectedskus.length ? selectedskus : normalizedCampaignSkuIds,
      },
      productOfferId: PID,
      startDate: CampaignDetails?.startDate || "",
    };
    try {
      const editPromotion = await PromotionController.editPromotion({
        Authorization: userService.getUser(),
        request: request,
      });
    } catch (error) {}
  };
  const HandleSavechanges = async () => {
    const request = {
      categoryId: selectedCategoryDetails.map((item) => item.id),
      description: description,
      discountValue: Number(value),
      discountValueType: discountUnit,
      endDate: dayjs(CampaignDetails?.endDate).format("MMM DD,YYYY"),
      offerType: CampaignOfferType,
      productAndSku: {
        productID: selectedproducts,
        skuId: selectedskus,
      },
      productOfferId: PID,
      startDate: dayjs(CampaignDetails?.startDate).format("MMM DD,YYYY"),
    };
    try {
      const editPromotion = await PromotionController.editPromotion({
        Authorization: userService.getUser(),
        request,
      });
      if (editPromotion.data === true) {
        navigate("/promotions-and-marketing");
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (DeleteCamp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [DeleteCamp]);
  return (
    <div className="business-hub-bar-screen">
      {DeleteCamp ? (
        <div className="delete-camp-pop-layer">
          <div className="delet-pop-container">
            <div className="delet-pop-container-icon">
              <BinIcon />
            </div>
            <div className="delet-pop-container-header">
              <div className="delet-pop-container-title">Cancel Campaign?</div>
              <div className="delet-pop-container-discription">
                This action cannot be undone
              </div>
            </div>
            <div className="delet-pop-container-alert">
              <div className="cancel-warning">
                <p className="cancel-warning-title">
                  <b>Warning:</b> Cancelling this campaign will:
                </p>

                <ul className="cancel-warning-list">
                  <li>Stop all promotional activities immediately</li>
                  <li>Remove discounts from all products</li>
                  <li>Performance data will be archived</li>
                </ul>
              </div>
            </div>
            <div className="delet-pop-container-action-buttons">
              <div
                className="delet-pop-container-cancel"
                onClick={() => {
                  DeletePromotion();
                  // setDeleteCamp(false);
                  // setMode(false);
                }}
              >
                Cancel Campaign
              </div>
              <div
                className="delet-pop-container-Keep"
                onClick={() => setDeleteCamp(false)}
              >
                Keep Campaign
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="business-hub-bar-header-container">
        <BusinessHubHeader />
      </div>
      <div className="active-promotion-page-design-content-container">
        <div className="business-hub-navigation-sidebar">
          <BusinessHubNavigation mode="prod" active="H" />
        </div>
        <div className="active-promotion-container">
          <div className="content-container-active-promotion">
            <div className="product-managemnet-qr-code-containers">
              {Mode ? (
                <div className="edit-promotion-header">
                  <div className="edit-promotion-header-title">
                    <div className="edit-promotion-header-title">
                      <div className="header-data-edit-campaign">
                        {/* <div className="promotion-marketing-header-title-disc">
                          Flash Sale
                        </div> */}
                        <div className="promotion-marketing-header-title-state">
                          {CampaignDetails?.campaignsStatus}
                        </div>
                      </div>
                      <div className="promotion-marketing-header-name">
                        Campaign Name
                      </div>
                      <div className="promotion-marketing-header-containers">
                        <div className="promotion-marketing-header-title">
                          {CampaignDetails?.promotionName}
                        </div>
                      </div>
                      <div className="edit-promotion-header-title">
                        <div className="promotion-marketing-header-name">
                          Short Description
                        </div>
                        <div className="promotion-marketing-header-containers">
                          <input
                            placeholder={CampaignDetails?.description}
                            className="promotion-marketing-header-title-discription"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="promotion-marketing-header-container">
                  <div className="promotion-marketing-header-data-container">
                    <div className="promotion-marketing-header-discription">
                      <div className="promotion-marketing-header-title">
                        {CampaignDetails?.promotionName}

                        <div
                          className={
                            CampaignDetails?.campaignsStatus === "ACTIVE"
                              ? "promotion-marketing-header-title-state"
                              : "promotion-marketing-header-title-state-sched"
                          }
                        >
                          {CampaignDetails?.campaignsStatus}
                        </div>
                      </div>
                      <div className="active-promotion-marketing-header-note">
                        {CampaignDetails?.description}
                      </div>
                    </div>
                    <div className="active-promotion-marketing-header-buttons">
                      <div
                        className="active-promotion-action-icon"
                        onClick={() => setMode(true)}
                      >
                        <EditDetails stroke="#4072C8" />
                      </div>
                      <div
                        className="active-promotion-action-icon"
                        onClick={() => {
                          setDeleteCamp(true);
                        }}
                      >
                        <TrashIcon w="18.5px" h="20px" fill="#F44336" />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="active-promotion-marketing-body">
                <div className="active-promotion-marketing-body-data">
                  {/***************************************Campaign info********************************** */}
                  {Mode ? (
                    <div className="active-promotion-marketing-body-data-cont">
                      <div className="active-promotion-marketing-body-data-row">
                        <div className="active-promotion-marketing-body-data-row-main-culomn">
                          <ProductBox />
                          Products in Campaign
                        </div>
                      </div>
                      <div className="active-promotion-marketing-body-specifics">
                        {/* <div className="active-promotion-marketing-body-data-row-culomn">
                          <div className="active-promotion-marketing-body-data-row-culomn-row">
                            Campaign Name
                          </div>
                          <CustomDropdown
                            rightIcon={<ArrowDownIcon />}
                            // value={categoryFilter}
                            // onChange={setCategoryFilter}
                            placeholder="Flash Sale"
                            options={[
                              { label: "All Status", value: "All STATUS" },
                              { label: "Active", value: "ACTIVE" },
                              { label: "Scheduled", value: "UPCOMING" },
                            ]}
                            className="active-promotion-marketing-body-data-row-culomn-row-input"
                            openClassName="promotion-marketing-create-body-content-drop-menu-open"
                            menuClassName="status-drop-menu-container"
                            optionClassName="catagory-status-drop-menu-option"
                          />
                        </div> */}
                        <div className="active-promotion-marketing-body-data-row-culomn">
                          {SelectFilter ? (
                            <div className="edit-campaign-selected-categs">
                              {/* <div className="active-promotion-marketing-body-data-row-culomn-row">
                                Category
                                <div
                                  className="filter-catagories-edit-campaign"
                                  onClick={() => setSelectFilter(true)}
                                >
                                  <FilterIcon />
                                  Filter Categories
                                </div>
                              </div> */}
                              <div className="active-info-marketing-body-data-row-culomn-row-datas">
                                <CustomDropdown
                                  multi
                                  searchable
                                  leftIcon={<FilterIcon />}
                                  value={selectedCategories}
                                  onChange={setSelectedCategories}
                                  placeholder={
                                    selectedCategories?.length
                                      ? `${selectedCategories.length} Selected`
                                      : "Select categories"
                                  }
                                  options={uniqueCategoryOptions.map(
                                    (item) => ({
                                      label: item.label || item.name || item.id,
                                      value: item.id,
                                    }),
                                  )}
                                  className="active-promotion-marketing-body-data-row-culomn-row-inputs"
                                  openClassName="promotion-marketing-create-body-content-drop-menu-open"
                                  menuClassName="status-drop-menu-containers"
                                  optionClassName="catagory-status-drop-menu-options"
                                />
                              </div>
                              {/********************************************************************************** */}
                              {/* <div className="active-promotion-marketing-body-data-row-culomn-row-datas">
                                <CustomDropdown
                                  multi
                                  searchable
                                  value={selectedCategories}
                                  onChange={setSelectedCategories}
                                  placeholder="Select Categories"
                                  options={CategoryFilters.map((item) => ({
                                    label: item.categoryName,
                                    value: item.value,
                                  }))}
                                  className="active-promotion-marketing-body-data-row-culomn-row-inputs"
                                  openClassName="promotion-marketing-create-body-content-drop-menu-open"
                                  menuClassName="status-drop-menu-containers"
                                  optionClassName="catagory-status-drop-menu-options"
                                />
                              </div> */}
                              {/********************************************************************************** */}
                            </div>
                          ) : (
                            <div className="edit-campaign-selected-categs">
                              <div className="active-promotion-marketing-body-data-row-culomn-row">
                                Category
                                <div
                                  className="filter-catagories-edit-campaigns"
                                  onClick={() => setSelectFilter(true)}
                                >
                                  <FilterIcon stroke="white" />
                                  {selectedCategories?.length} Selected
                                </div>
                              </div>
                              <div className="active-promotion-marketing-body-data-row-culomn-row-datas">
                                {selectedCategoryDetails.map((category) => (
                                  <div
                                    key={category.id}
                                    className="selected-category-item"
                                  >
                                    <span className="category-name">
                                      {category.label || category.name}
                                    </span>
                                    {category.count ? (
                                      <span className="category-name">
                                        ({category.count})
                                      </span>
                                    ) : null}
                                    <div
                                      className="remove-category-btn"
                                      onClick={() =>
                                        handleRemoveCategory(category)
                                      }
                                    >
                                      <XIcon />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          {/********************************************************************* */}
                          <div className="campaign-info-panels">
                            <div className="campaign-products-filtersearch">
                              <input
                                type="text"
                                className="campaign-products-filterinput"
                                placeholder="Search products or SKUs..."
                                value={productsearch}
                                onChange={(e) =>
                                  setProductsearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="campaign-products-skus-list">
                              {visibleproducts?.length === 0 ? (
                                <div className="edit-profs-campaign-empty">
                                  <div className="edit-profs-campaign-empty-icon">
                                    <BoxIcon />
                                  </div>
                                  <div className="edit-profs-campaign-empty-text">
                                    No products match the selected categories
                                  </div>
                                  <div className="edit-profs-campaign-empty-alert">
                                    Try changing category filters or search
                                  </div>
                                </div>
                              ) : (
                                visibleproducts.map((product) => {
                                  const isselected = selectedproducts.includes(
                                    product.id,
                                  );
                                  const isexpanded = expandedproducts.includes(
                                    product.id,
                                  );
                                  const selectedcount = product.skus.filter(
                                    (sku) => selectedskus.includes(sku.id),
                                  ).length;

                                  return (
                                    <div
                                      key={product.id}
                                      className={`campaign-products-sku-product${
                                        isselected
                                          ? " campaign-products-sku-product-active"
                                          : ""
                                      }`}
                                    >
                                      <div
                                        className="campaign-products-items"
                                        onClick={() =>
                                          handleToggleProduct(product)
                                        }
                                      >
                                        <div className="campaign-products-item-checkbox">
                                          <div
                                            className={`campaign-products-item-checkbox-inner${
                                              isselected
                                                ? " campaign-products-item-checkbox-inner-active"
                                                : ""
                                            }`}
                                          ></div>
                                        </div>
                                        <div className="active-campaign-products-item-avatar">
                                          {/*  */}
                                          {product.image ? (
                                            <img
                                              src={product.image}
                                              className="campaign-products-item-avatar-img"
                                            ></img>
                                          ) : (
                                            <div>
                                              {product.name.slice(0, 1)}
                                            </div>
                                          )}
                                        </div>
                                        <div className="campaign-products-item-info">
                                          <div className="campaign-products-item-name">
                                            {product.name}
                                          </div>
                                          <div className="campaign-products-item-meta">
                                            {product?.skus?.length} variants
                                            available
                                            {selectedcount
                                              ? ` • ${selectedcount} selected`
                                              : ""}
                                          </div>
                                        </div>
                                        <div className="campaign-products-item-arrow">
                                          <ArrowDownIcon />
                                        </div>
                                      </div>
                                      {isexpanded ? (
                                        <div className="campaign-products-skulist">
                                          {product.skus.map((sku) => {
                                            const isskuselected =
                                              selectedskus.includes(sku.id);

                                            return (
                                              <div
                                                key={sku.id}
                                                className="campaign-products-skuitem"
                                                onClick={() =>
                                                  handleToggleSku(
                                                    product,
                                                    sku.id,
                                                  )
                                                }
                                              >
                                                <div className="campaign-products-skucheck">
                                                  <div
                                                    className={`campaign-products-skucheckinner${
                                                      isskuselected
                                                        ? " campaign-products-skucheckinner-active"
                                                        : ""
                                                    }`}
                                                  ></div>
                                                </div>
                                                <div className="campaign-products-skuinfo">
                                                  <div className="campaign-products-skuname">
                                                    {sku.color}
                                                  </div>
                                                  <div className="campaign-products-skucode">
                                                    {sku.code}
                                                  </div>
                                                </div>
                                                <div className="campaign-products-skustock">
                                                  Stock {sku.stock}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : null}
                                    </div>
                                  );
                                })
                              )}
                            </div>
                          </div>
                          {/********************************************************************* */}
                        </div>
                      </div>
                      <CustomDropdown
                        value={selectedSummaryLabel}
                        className="selected-prods-skus-camp"
                        menuClassName="selected-prods-skus-camp-menu"
                        renderTrigger={({ open }) => (
                          <div className="selected-prods-skus-camp-trigger">
                            <div className="selected-prods-skus-camp-copy">
                              <div className="selected-prods-skus-camp-title">
                                {selectedSummaryLabel}
                              </div>
                              <div className="selected-prods-skus-camp-meta">
                                {selectedSummaryMeta}
                              </div>
                            </div>
                            <div
                              className={`selected-prods-skus-camp-arrow${
                                open
                                  ? " selected-prods-skus-camp-arrow-open"
                                  : ""
                              }`}
                            >
                              <ArrowDownIcon />
                            </div>
                          </div>
                        )}
                        renderMenu={() => (
                          <div className="selected-prods-skus-camp-menu-body">
                            {selectedProductDetails?.length ? (
                              selectedProductDetails.map((product) => {
                                const productSelectedSkus = product.skus.filter(
                                  (sku) => selectedskus.includes(sku.id),
                                );
                                const variantText =
                                  productSelectedSkus?.length ===
                                  product?.skus?.length
                                    ? `${productSelectedSkus?.length} of ${product?.skus?.length} variants`
                                    : productSelectedSkus
                                        .map((sku) => sku.name)
                                        .join(", ");

                                return (
                                  <div
                                    key={product.id}
                                    className="selected-prods-skus-camp-card"
                                  >
                                    <div className="selected-prods-skus-camp-card-main">
                                      <div className="selected-prods-skus-camp-card-avatar">
                                        {product.image ? (
                                          <img
                                            src={product.image}
                                            alt={product.name}
                                            className="selected-prods-skus-camp-card-image"
                                          />
                                        ) : (
                                          product.name.slice(0, 1)
                                        )}
                                      </div>
                                      <div className="selected-prods-skus-camp-card-copy">
                                        <div className="selected-prods-skus-camp-card-title">
                                          {product.name}
                                        </div>
                                        <div className="selected-prods-skus-camp-card-meta">
                                          {variantText}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="selected-prods-skus-camp-card-remove"
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleToggleProduct(product);
                                      }}
                                    >
                                      <XIcon />
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="selected-prods-skus-camp-empty">
                                No selected products or SKUs yet
                              </div>
                            )}
                          </div>
                        )}
                      />
                      <div className="active-promotion-marketing-body-specifics">
                        <div className="active-promotion-marketing-body-data-row-culomn">
                          <div className="active-promotion-marketing-body-data-row-culomn-row">
                            Discount
                          </div>
                          <div className="edit-campaign-discount">
                            <input
                              placeholder={CampaignDetails?.discountValue}
                              className="active-promotion-marketing-body-data-row-culomn-row-data-input"
                              type="text"
                              inputMode="decimal"
                              pattern="[0-9]*"
                              value={value}
                              onChange={(e) => {
                                const onlyNums = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );
                                setValue(onlyNums);
                              }}
                            ></input>
                            <div className="campaign-discount-unit-switchs">
                              <div
                                className={`campaign-discount-units${
                                  discountUnit === "PERCENTAGE" || !discountUnit
                                    ? " campaign-discount-unit-actives"
                                    : ""
                                }`}
                                onClick={() => setDiscountUnit("PERCENTAGE")}
                              >
                                %
                              </div>
                              <div
                                className={`campaign-discount-units${
                                  discountUnit === "VALUE"
                                    ? " campaign-discount-unit-actives"
                                    : ""
                                }`}
                                onClick={() => setDiscountUnit("VALUE")}
                              >
                                $
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          Credits Used
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          40
                        </div>
                      </div> */}
                      </div>
                    </div>
                  ) : (
                    <div className="active-promotion-marketing-body-data-cont">
                      <div className="active-promotion-marketing-body-data-row">
                        <div className="active-promotion-marketing-body-data-row-main-culomn">
                          <ProductBox />
                          Products in Campaign
                        </div>
                      </div>
                      <div className="view-prod-camp-catg">
                        <div className="view-prod-camp-catg-title">
                          Category
                        </div>
                        <div className="view-prod-camp-catg-text">
                          {selectedCategorySummary}
                        </div>
                      </div>
                      {productsInCampaign?.length === 0 ? (
                        <div className="edit-profs-campaign-empty">
                          <div className="edit-profs-campaign-empty-icon">
                            <BoxIcon />
                          </div>
                          <div className="edit-profs-campaign-empty-text">
                            No products in this campaign
                          </div>
                          <div className="edit-profs-campaign-empty-alert">
                            ⚠ Campaign must have at least one product
                          </div>
                        </div>
                      ) : (
                        <div className="products-in-campaign">
                          <div className="prods-camp-skus-list">
                            Products & SKUs
                          </div>
                          {productsInCampaign?.map((product) => (
                            <div
                              className="products-card-in-campaign"
                              key={
                                product?.productId ??
                                product?.productID ??
                                product?.id
                              }
                            >
                              <div className="products-card-in-campaign-disc">
                                {product?.productImages?.length ? (
                                  <img
                                    src={product?.productImages[0]}
                                    alt={product?.title ?? product?.productName}
                                    className="prod-camp-image"
                                  />
                                ) : (
                                  <div className="prod-camp-image" />
                                )}
                                <div className="prods-in-camp-text">
                                  <div className="prods-in-camp-title">
                                    {product?.productName}
                                  </div>
                                  <div className="prods-in-camp-note">
                                    {/* {(() => {
                                      const selectedCampaignSkuIds = new Set(
                                        getCampaignSkuIds(CampaignDetails),
                                      );
                                      const matchingSkus = (
                                        Array.isArray(product?.skus)
                                          ? product.skus
                                          : []
                                      ).filter((sku) =>
                                        selectedCampaignSkuIds.has(
                                          String(
                                            sku?.skuID ?? sku?.skuId ?? sku?.id,
                                          ),
                                        ),
                                      );

                                      if (!matchingSkus.length) {
                                        return "No SKU assigned";
                                      }

                                      return matchingSkus
                                        .map((sku) => getSkuDisplayText(sku))
                                        .join(", ");
                                    })()} */}
                                    {product?.skus[0]?.skuCode}
                                  </div>
                                </div>
                              </div>
                              {Mode ? (
                                <div className="remove-product-from-campaign">
                                  <XIcon />
                                </div>
                              ) : null}
                              {/* <div className="products-card-in-campaign-discount">
                            <div className="prods-in-camp-note">
                              Discount Applied
                            </div>
                            <div className="products-card-in-campaign-discount-ammount">
                              {product.discount}
                            </div>
                          </div> */}
                            </div>
                          ))}
                        </div>
                      )}
                      <div className="prod-camp-old-discount">
                        <div className="prod-camp-old-discount-rate">
                          Discount
                        </div>
                        <div className="prod-camp-old-discount-number">
                          {CampaignDetails?.discountApplied}
                        </div>
                      </div>
                      {Mode ? (
                        <div
                          className="edit-campaign-add-prods-skus"
                          onClick={() => setaddProdSku(true)}
                        >
                          <PlusIcon fill="#4072C8" />
                          Add Products & SKUs
                        </div>
                      ) : null}
                      {addProdSku ? (
                        <div className="edit-campaign-add-prods-sku">
                          <div className="edit-campaign-add-prods-sku-search">
                            <SearchIcon />
                            <input
                              placeholder="Search products or SKUs..."
                              className="edit-campaign-add-prods-sku-input"
                            ></input>
                          </div>
                          {/* <div className="edit-campaign-add-prods-sku">
                          <div className="campaign-products-panel">
                            <div className="campaign-products-filtersearch">
                              <input
                                type="text"
                                className="campaign-products-filterinput"
                                placeholder="Search products or SKUs..."
                                value={productsearch}
                                onChange={(e) =>
                                  setProductsearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="campaign-products-list">
                              {visibleproducts.map((product) => {
                                const isselected = selectedproducts.includes(
                                  product.id,
                                );
                                const isexpanded = expandedproducts.includes(
                                  product.id,
                                );
                                const selectedcount = product.skus.filter(
                                  (sku) => selectedskus.includes(sku.id),
                                ).length;

                                return (
                                  <div
                                    key={product.id}
                                    className={`campaign-products-product${
                                      isselected
                                        ? " campaign-products-product-active"
                                        : ""
                                    }`}
                                  >
                                    <div
                                      className="campaign-products-item"
                                      onClick={() => {
                                        if (isselected) {
                                          setSelectedproducts((prev) =>
                                            prev.filter(
                                              (item) => item !== product.id,
                                            ),
                                          );
                                          setExpandedproducts((prev) =>
                                            prev.filter(
                                              (item) => item !== product.id,
                                            ),
                                          );
                                          setSelectedskus((prev) =>
                                            prev.filter(
                                              (skuId) =>
                                                !product.skus.some(
                                                  (sku) => sku.id === skuId,
                                                ),
                                            ),
                                          );
                                          return;
                                        }

                                        setSelectedproducts((prev) => [
                                          ...prev,
                                          product.id,
                                        ]);
                                        setExpandedproducts((prev) =>
                                          prev.includes(product.id)
                                            ? prev
                                            : [...prev, product.id],
                                        );
                                      }}
                                    >
                                      <div className="campaign-products-item-checkbox">
                                        <div
                                          className={`campaign-products-item-checkbox-inner${
                                            isselected
                                              ? " campaign-products-item-checkbox-inner-active"
                                              : ""
                                          }`}
                                        ></div>
                                      </div>
                                      <div className="campaign-products-item-avatar">
                                        {product.name.slice(0, 1)}
                                      </div>
                                      <div className="campaign-products-item-info">
                                        <div className="campaign-products-item-name">
                                          {product.name}
                                        </div>
                                        <div className="campaign-products-item-meta">
                                          {product.skus.length} variants
                                          available
                                          {selectedcount
                                            ? ` • ${selectedcount} selected`
                                            : ""}
                                        </div>
                                      </div>
                                      <div className="campaign-products-item-arrow">
                                        <ArrowDownIcon />
                                      </div>
                                    </div>
                                    {isexpanded ? (
                                      <div className="campaign-products-skulist">
                                        {product.skus.map((sku) => {
                                          const isskuselected =
                                            selectedskus.includes(sku.id);

                                          return (
                                            <div
                                              key={sku.id}
                                              className="campaign-products-skuitem"
                                              onClick={() =>
                                                setSelectedskus((prev) =>
                                                  prev.includes(sku.id)
                                                    ? prev.filter(
                                                        (item) =>
                                                          item !== sku.id,
                                                      )
                                                    : [...prev, sku.id],
                                                )
                                              }
                                            >
                                              <div className="campaign-products-skucheck">
                                                <div
                                                  className={`campaign-products-skucheckinner${
                                                    isskuselected
                                                      ? " campaign-products-skucheckinner-active"
                                                      : ""
                                                  }`}
                                                ></div>
                                              </div>
                                              <div className="campaign-products-skuinfo">
                                                <div className="campaign-products-skuname">
                                                  {sku.name}
                                                </div>
                                                <div className="campaign-products-skucode">
                                                  {sku.code}
                                                </div>
                                              </div>
                                              <div className="campaign-products-skustock">
                                                Stock {sku.stock}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div> */}
                        </div>
                      ) : null}
                    </div>
                  )}
                  {/* **************************************Products in Campaign ********************************** */}

                  {/***************************************Campaign Schedule********************************** */}
                  <div className="active-promotion-marketing-body-data-cont">
                    <div className="active-promotion-marketing-body-data-row">
                      <div className="active-promotion-marketing-body-data-row-main-culomn">
                        <DateIcon strokeWidth="1.4" />
                        Campaign Schedule
                      </div>
                    </div>
                    <div className="active-promotion-marketing-body-specifics">
                      <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          Start Date
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          {formatDisplayDate(CampaignDetails?.startDate)}
                        </div>
                      </div>
                      <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          End Date
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          {formatDisplayDate(CampaignDetails?.endDate)}
                        </div>
                      </div>
                    </div>
                    <div className="active-promotion-marketing-body-specifics">
                      <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          Campaign Duration
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          {CampaignDetails?.campaignDuration}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="active-promotion-marketing-body-analitics">
                  <div className="active-promotion-marketing-body-analitics-status">
                    <div className="active-promotion-body-analitics-title">
                      Campaign Status
                    </div>
                    <div className="active-promotion-body-analitics-state">
                      {formatStatus(CampaignDetails?.campaignsStatus)}
                    </div>
                    {CampaignDetails?.campaignsStatus === "SCHEDULED" ? null : (
                      <div className="active-promotion-body-analitics-actuale">
                        <span className="comp-status"></span> Running Now
                      </div>
                    )}
                  </div>
                  <div className="active-promotion-marketing-body-analitics-performance">
                    <div className="active-promotion-marketing-analitics-performance-container">
                      <div className="active-promotion-marketing-analitics-performance-header">
                        Performance
                      </div>
                      <div className="active-promotion-marketing-analitics-performance-body">
                      
                        <div className="active-promotion-marketing-analitics-performance-body-row">
                          <div className="active-promotion-marketing-analitics-performance-row-header">
                            <div className="active-promotion-marketing-analitics-performance-row-title">
                              Views
                            </div>
                            <div className="active-promotion-marketing-analitics-performance-row-numb">
                              {views}
                            </div>
                          </div>
                          <div className="active-promotion-marketing-analitics-performance-row-body">
                            <div
                              className="range-fill"
                           
                            />
                          </div>
                        </div>
                    
                        <div className="active-promotion-marketing-analitics-performance-body-row">
                          <div className="active-promotion-marketing-analitics-performance-row-header">
                            <div className="active-promotion-marketing-analitics-performance-row-title">
                              Clicks
                            </div>
                            <div className="active-promotion-marketing-analitics-performance-row-numb">
                              {clicks}
                            </div>
                          </div>
                          <div className="active-promotion-marketing-analitics-performance-row-body">
                            <div
                              className="range-fill"
                              style={{ width: `${Clickrange}%` }}
                            />
                          </div>
                        </div>
                     
                        <div className="active-promotion-marketing-analitics-performance-body-row">
                          <div className="active-promotion-marketing-analitics-performance-row-header">
                            <div className="active-promotion-marketing-analitics-performance-row-title">
                              Conversions
                            </div>
                            <div className="active-promotion-marketing-analitics-performance-row-numb">
                              {conversion}
                            </div>
                          </div>
                          <div className="active-promotion-marketing-analitics-performance-row-body">
                            <div
                              className="range-fills"
                              style={{ width: `${Convrange}%` }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                </div> */}
              </div>
              {Mode ? (
                <div className="edit-promotion-footer">
                  <div className="edit-promotion-footer-text">
                    Make changes to your campaign details and schedule
                  </div>
                  <div className="edit-promotion-footer-action-button">
                    <div
                      className="edit-promotion-footer-discard"
                      onClick={() => setDeleteCamp(true)}
                    >
                      Delete Change
                    </div>
                    <div
                      className="edit-promotion-footer-save"
                      onClick={() => HandleSavechanges()}
                    >
                      <SaveIcon />
                      Save Changes
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActivePromotion;
